// action types
import { createRequestTypes } from "../../utils";

export const SYNC_BREVO = createRequestTypes("SYNC_BREVO");

export const syncBrevoRequest = () =>
  ({ type: SYNC_BREVO.REQUEST });

export const syncBrevoSuccess = () =>
  ({ type: SYNC_BREVO.SUCCESS, payload: true });

export const syncBrevoFailure = (error) =>
  ({ type: SYNC_BREVO.FAILURE, payload: error });

// Send Mailing Campaign
export const SEND_MAILING_CAMPAIGN = createRequestTypes("SEND_MAILING_CAMPAIGN");

export const sendMailingCampaignRequest = (template_id, campaign_id, quantity, hour, minutes, subject) =>
  ({ type: SEND_MAILING_CAMPAIGN.REQUEST, payload: { template_id, campaign_id, quantity, hour, minutes, subject } });

export const sendMailingCampaignSuccess = (response) =>
  ({ type: SEND_MAILING_CAMPAIGN.SUCCESS, payload: response });

export const sendMailingCampaignFailure = (error) =>
  ({ type: SEND_MAILING_CAMPAIGN.FAILURE, payload: error });
